import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Alert,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";
import axiosApi from "../servicios/axios.service";
import {
  generateAlphanumericString,
  validateCIF,
  validateEmail,
  validateNIE,
  validateNIF,
  validatePhone,
  crearEmpresa,
} from "../servicios/auth.service"; // Importamos funciones de validación

const ModalNuevoCliente = ({ open, onClose, onClienteAgregado }) => {
  const [formData, setFormData] = useState({
    personaContacto: "",
    telefono: "",
    email: "",
    nombreEmpresa: "",
    nombreFiscal: "",
    cif: "",
    direccion: "",
    codigoPostal: "",
    localidad: "",
    provincia: "",
    crearcuentaPanel: true,
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, crearcuentaPanel: e.target.checked });
  };
  const handleGuardarCliente = async () => {
    setError("");
    setSuccess("");

    // Validación de campos obligatorios
    const camposObligatorios = [
      "personaContacto",
      "telefono",
      "email",
      "nombreEmpresa",
      "nombreFiscal",
      "cif",
      "direccion",
      "codigoPostal",
      "localidad",
      "provincia",
    ];

    for (const campo of camposObligatorios) {
      if (!formData[campo]) {
        setError(
          `Por favor, completa el campo ${campo
            .replace(/([A-Z])/g, " $1")
            .toLowerCase()}.`
        );
        return;
      }
    }

    // Validaciones específicas
    if (!validatePhone(formData.telefono)) {
      setError("El teléfono debe contener 9 dígitos válidos.");
      return;
    }

    if (!validateEmail(formData.email)) {
      setError("Por favor, introduce un email válido.");
      return;
    }

    if (
      !validateCIF(formData.cif) &&
      !validateNIF(formData.cif) &&
      !validateNIE(formData.cif)
    ) {
      setError("El CIF, NIF o NIE proporcionado no es válido.");
      return;
    }
    console.log(formData);
    // return;
    try {
      await crearEmpresa(formData);
      setSuccess("Cliente agregado correctamente.");

      setFormData({
        personaContacto: "",
        telefono: "",
        email: "",
        nombreEmpresa: "",
        nombreFiscal: "",
        cif: "",
        direccion: "",
        codigoPostal: "",
        localidad: "",
        provincia: "",
        crearcuentaPanel: true,
      });

      onClienteAgregado();
      setTimeout(() => {
        setSuccess("");
        onClose();
      }, 1500);
    } catch (error) {
      setError("Error al guardar el cliente.");
      console.error("Error al guardar cliente", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Añadir Cliente</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={12}>
            <TextField
              label="Persona de contacto (Administrador por defecto)"
              name="personaContacto"
              value={formData.personaContacto}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Teléfono"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              fullWidth
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {/* ✅ Checkbox para crear cuenta en Panel */}
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.crearcuentaPanel}
                  onChange={handleCheckboxChange}
                  color="primary"
                />
              }
              label="Crear cuenta en Panel"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Nombre Fiscal"
              name="nombreFiscal"
              value={formData.nombreFiscal}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Nombre Comercial"
              name="nombreEmpresa"
              value={formData.nombreEmpresa}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="CIF, NIF o NIE"
              name="cif"
              value={formData.cif}
              onChange={handleChange}
              fullWidth
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BusinessIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Dirección"
              name="direccion"
              value={formData.direccion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Código Postal"
              name="codigoPostal"
              value={formData.codigoPostal}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Localidad"
              name="localidad"
              value={formData.localidad}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Provincia"
              name="provincia"
              value={formData.provincia}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleGuardarCliente}
          color="primary"
          variant="contained"
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalNuevoCliente;
